<div class="spinner-over-lay"></div>

<div class="plane-loader">
  <app-plane-loader [showLoading]="showLoading" />
</div>
